import { useEffect, useState } from "react";

const TEMPLATE_CARD_SIZES = {
  default: { width: 240, height: 330 },
  sm: { width: 250, height: 345 },
  md: { width: 260, height: 360 },
} as const;

const BREAKPOINTS = { sm: 640, md: 768 } as const;

type SizeKey = keyof typeof TEMPLATE_CARD_SIZES;

const getBreakpoint = (width: number): SizeKey => {
  if (width >= BREAKPOINTS.md) return "md";
  if (width >= BREAKPOINTS.sm) return "sm";
  return "default";
};

export const useTemplateCardSize = () => {
  const [currentSize, setCurrentSize] = useState<SizeKey>("default");

  useEffect(() => {
    const updateSize = () => setCurrentSize(getBreakpoint(window.innerWidth));
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return {
    currentSize,
    dimensions: TEMPLATE_CARD_SIZES[currentSize],
    gridClasses:
      "grid-cols-[repeat(auto-fill,_240px)] sm:grid-cols-[repeat(auto-fill,_250px)] md:grid-cols-[repeat(auto-fill,_260px)]",
    cardWidthClasses: "w-[240px] sm:w-[250px] md:w-[260px]",
    cardHeightClasses: "h-[330px] sm:h-[345px] md:h-[360px]",
  };
};

export const getResponsiveGridClasses = () =>
  "grid-cols-[repeat(auto-fill,_240px)] sm:grid-cols-[repeat(auto-fill,_250px)] md:grid-cols-[repeat(auto-fill,_260px)]";

export const getResponsiveCardClasses = () => ({
  width: "w-[240px] sm:w-[250px] md:w-[260px]",
  height: "h-[330px] sm:h-[345px] md:h-[360px]",
});
